var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-preview"},[_c('iframe',{staticClass:"full-screen-preview__frame",staticStyle:{"height":"100vh"},attrs:{"src":"https://landing.instantpayment.in/","name":"preview-frame","frameborder":"0","noresize":"noresize","data-view":"fullScreenPreview","allow":"geolocation 'self'; autoplay 'self'"}})])
}]

export { render, staticRenderFns }